module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('m-header', {
    attrs: {
      "title": "关于我们"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', [_vm._v("当前版本号:" + _vm._s(_vm.ver))]), _vm._v(" "), _c('div', {
    staticClass: "des text-l"
  }, [_vm._v("快买酒，位于国门顺义天竺综合保税区，依托保税区优势，服务于国内葡萄酒经营商；10余年进口葡萄酒进口商，海外酒庄收购经验；互联网技术加运营完整编制团队，提供微电商解决方案，包括商品，订单，支付，结算，账号，分享等一整套功能。配合相应的数据服务，实现完整的交易全链路闭环。")]), _vm._v(" "), _c('div', {
    staticClass: "text-l pf flex-1"
  }, [(_vm.system == 'ios') ? _c('a', {
    staticClass: "vux-1px-b ",
    attrs: {
      "href": "https://itunes.apple.com/cn/app/快买酒/id1142862408?mt=8"
    }
  }, [_vm._v("\n            给快买酒评分"), _c('i', {
    staticClass: "icon-youjiantou-copy iconfont fr"
  })]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "color-666"
  }, [_vm._v("广德盛源（北京） 信息技术有限公司 2015-2017")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95e65daa"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/about/about.vue
// module id = 600
// module chunks = 0